import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { TSubmittedData } from '@/shared/components/ui/form/form.types';
import { TAddResourcesToGroupInputSchema } from '@/shared/features/groups/components/add-resources-to-group/add-resources-to-group.validation';
import { useGroupsConfig } from '@/shared/features/groups/context/groups-config-context';
import { TGroupResourceItem } from '@/shared/features/groups/context/groups-config-context.types';
import { showToastError } from '@/shared/utils/toast';

export const useGroupResourceActions = () => {
  const { t } = useTranslation();
  const { createResourceUpdatePromises } =
    useGroupsConfig().useResourceUpdatePromises();

  const handleAddResourcesToGroup = async (
    data: TSubmittedData<TAddResourcesToGroupInputSchema>,
    resources: TGroupResourceItem[],
    onSuccess?: () => void,
    onClose?: () => void,
  ) => {
    try {
      const promises = createResourceUpdatePromises(
        resources,
        data.data.groupId,
      );
      await Promise.all(promises);
      toast.success(t('groups:drawer.update_group.update_success'));
      onSuccess?.();
      onClose?.();
    } catch {
      showToastError(t('groups:drawer.update_group.update_error'));
    }
  };

  return { createResourceUpdatePromises, handleAddResourcesToGroup };
};
